module.exports = __webpack_public_path__ + "32472779bb3e7de0f569b0dece395cc0.jpg";